export default __webpack_public_path__ + "static/media/40.4c3eff01.png";